import FilterBase from './filter-base';
import FilterBox from './filter-box';
import { FilterActiveValue } from './active-filters';

export default class CheckboxValueFilter extends FilterBase {

    private checkbox: HTMLInputElement;
    private valueInput: HTMLInputElement;
    private clearButton: HTMLSpanElement;

    constructor(baseElement: HTMLElement, filterBox: FilterBox) {
        super(baseElement, filterBox);
        this.checkbox = baseElement.querySelector('input[data-component-part="Checkbox"]');
        this.valueInput = baseElement.querySelector('input[data-component-part="ValueInput"]');
        this.clearButton = baseElement.querySelector('span[data-component-part="ClearButton"]');
    }

    public init(){
        this.checkbox.onchange = () => this.checkboxValueChanged();
        this.valueInput.onkeyup = () => this.onInputKeyUp(this.getValueNumber());
        this.clearButton.onclick = () => this.clear();
    }

    public setValuesInternal(value: string): Promise<void> {
        if (!value) {
            return;
        }
        this.checkbox.checked = true;
        const intValue = parseInt(value);
        this.valueInput.value = intValue ? intValue.toString() : '';
        this.valueInput.removeAttribute('disabled');

        return Promise.resolve();
    }

    protected clearValuesInternal(): void {
        this.checkbox.checked = false;
        this.valueInput.value = '';
        this.valueInput.disabled = true;
    }

    public unselect(values: string){
        this.clear();
    }

    protected getActiveFilterValues(): FilterActiveValue[] {
        if (!this.checkbox.checked) {
            return [];
        }
        const value = this.getValueNumber();
        return [<FilterActiveValue> { value: value, displayName: `${this.checkbox.name} > ${value}` }];
    }

    protected getSelectedValuesConcat(): string {
        if(!this.checkbox.checked) {
            return null;
        }

        return this.getValueNumber().toString();
    }

    private onInputKeyUp(value: number) {
        setTimeout(() => this.updateIfValueStill(value), 600);
    }

    private updateIfValueStill(value: number) {
        if (this.getValueNumber() !== value)
            return;

        this.updateAttributeAndApplyChanges();
    }

    private getValueNumber() {
        const value = Number.parseInt(this.valueInput.value);
        return value && value >= 0 ? value : 0;
    }

    protected clear() {
        this.clearValues();
        this.updateAttributeAndApplyChanges();
    }

    private checkboxValueChanged(){
        if (this.checkbox.checked) {
            this.valueInput.removeAttribute('disabled');
            if(isNaN(parseInt(this.valueInput.value))){
                this.valueInput.value = '100';
            }
        } else {
            this.valueInput.value = '';
            this.valueInput.disabled = true;
        }

        this.updateAttributeAndApplyChanges();
    }

}
